import httpClient from "../http/http-client";
import { IEnergySupplierTariffDetails, IPostEnergySupplierTariffDetails } from './energy-supplier-tariff-details.model';

export default class EnergySupplierTariffDetailsService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAllWithPagination(page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc', energySupplierTariffId?: string): Promise<{ count: number, rows: IEnergySupplierTariffDetails[] }> {
    return this.http.get(`energy-supplier-tariff-detail?page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}${energySupplierTariffId ? `&energySupplierTariffId=${energySupplierTariffId}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async getOne(energySupplierTariffDetailsId: string): Promise<IEnergySupplierTariffDetails> {
    return this.http.get(`energy-supplier-tariff-detail/${energySupplierTariffDetailsId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async create(energySupplierTariffDetails: IPostEnergySupplierTariffDetails): Promise<IEnergySupplierTariffDetails> {
    return this.http.post('energy-supplier-tariff-detail', energySupplierTariffDetails)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async edit(energySupplierTariffDetailsId: string, energySupplierTariff: Partial<IPostEnergySupplierTariffDetails>): Promise<IEnergySupplierTariffDetails> {
    return this.http.patch(`energy-supplier-tariff-detail/${energySupplierTariffDetailsId}`, energySupplierTariff)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }
}

